import { useEffect } from "react";
import { useSelector } from "react-redux";

import { isInIframe } from "helpers/app";
import { selectIsAppLoaded } from "store/features/app/selectors";

import { useMessenger } from "./use-messenger";

export const useIframeSendAppDataLoadedMessage = (): void => {
  const isAppDataLoaded = useSelector(selectIsAppLoaded);

  const embeddedInIframe = isInIframe();

  const { sendMessage } = useMessenger<
    never,
    {
      type: "helpdesk:app:loaded";
    }
  >(() => {});

  useEffect(() => {
    if (isAppDataLoaded && embeddedInIframe) {
      sendMessage({
        type: "helpdesk:app:loaded",
      });
    }
  }, [isAppDataLoaded, sendMessage, embeddedInIframe]);
};
